import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Grid,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { getSalesOrderDetail, editGuestDetail, returnUpdate } from "../actions";
import Header from "../Components/header";
import NavigationButtons from "../Components/navigationButton";
import SectionForm from "../Components/sectionForm";
import CustomRadioButton from "../Components/customRadio";
import {splitDateTime, mergeDateTime, isDifferentValue, getPicklist} from '../util/helpers'
import Swal from "sweetalert2";
import InputDate from "../../../components/global/InputDate";
import dayjs from "dayjs";
import { withTranslation } from "react-i18next";

const { URL_PREFIX } = window;

class VF2Step4 extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      isGetDataLoading: false,
      isOpen: false,
      form: {
        Update_For__c: "", // Default value for radio button
        arrivalDate: "", // Date of arrival in Bali
        arrivalTime: "", // Time of arrival
        Arrival_Flight_No__c: "", // Arrival Flight Number
        departureDate: "", // Departure Date from Bali
        departureTime: "", // Time of departure
        Departure_Flight_No__c: "", // Departure Flight Number
        Estimated_Luggage_Weight__c: "", // Estimated Luggage Weight
        Arrival_Hotel__c: "", // Hotel Name
        My_travel_agent__c: "", // Travel Agent or Contact Person
        Any_other_special_requests_for_our_Bali__c: "", // Special requests for the Bali office
      },
    };
  }

  componentDidMount() {
    const { guestDetail } = this.props.vf2; // Assuming guestDetail is passed via props

    if (guestDetail) {
      this.setState({
        form: {
          Update_For__c: guestDetail.Update_For__c,
          arrivalDate: splitDateTime(guestDetail.Arrival_Date_Time__c, 'date') ?? '',
          arrivalTime: splitDateTime(guestDetail.Arrival_Date_Time__c, 'time')?? '',
          Arrival_Flight_No__c: guestDetail.Arrival_Flight_No__c ?? '',
          departureDate: splitDateTime(guestDetail.Departure_Date_Time_back_home__c, 'date') ?? '',
          departureTime: splitDateTime(guestDetail.Departure_Date_Time_back_home__c, 'time') ?? '',
          Departure_Flight_No__c: guestDetail.Departure_Flight_No__c ?? '',
          Estimated_Luggage_Weight__c: guestDetail.Estimated_Luggage_Weight__c ?? '',
          Arrival_Hotel__c: guestDetail.Arrival_Hotel__c ?? '',
          My_travel_agent__c: guestDetail.My_travel_agent__c ?? '',
          Any_other_special_requests_for_our_Bali__c: guestDetail.Any_other_special_requests_for_our_Bali__c ?? '',
        },
      });
    }
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => {
      const updatedForm = { ...prevState.form, [name]: value };

      if (name === 'arrivalDate' && value && value !== 'Invalid Date') {
        const arrivalDate = new Date(value);
        if (!prevState.form.departureDate) {
          const departureDate = new Date(value);
          departureDate.setDate(departureDate.getDate() + 1);
          updatedForm.departureDate = departureDate.toISOString().split('T')[0];
        } else {
          console.log(arrivalDate, value)
          const departureDate = new Date(prevState.form.departureDate);
          departureDate.setMonth(arrivalDate.getMonth());
          departureDate.setFullYear(arrivalDate.getFullYear());
          if (departureDate.getDate() > new Date(arrivalDate.getFullYear(), arrivalDate.getMonth() + 1, 0).getDate()) {
            departureDate.setDate(new Date(arrivalDate.getFullYear(), arrivalDate.getMonth() + 1, 0).getDate());
          }
          updatedForm.departureDate = departureDate.toISOString().split('T')[0];
        }
      }

      return { form: updatedForm };
    });
  };

  handleSave = async () => {
    let payload = {...this.state.form};
    
    this.setState({ isLoading: true });
    try {
      payload.Arrival_Date_Time__c = mergeDateTime(payload.arrivalDate, payload.arrivalTime, 'Arrival Date')
      payload.Departure_Date_Time_back_home__c = mergeDateTime(payload.departureDate, payload.departureTime, 'Departure Date')
      delete payload.arrivalDate
      delete payload.arrivalTime
      delete payload.departureDate
      delete payload.departureTime
      const {guestDetail} = this.props.vf2
      if(isDifferentValue(payload, guestDetail)){
        await this.props.editGuestDetail(payload, guestDetail.Id, this.props.returnUpdate, 'detail');
      }
    } catch (error) {
      let errorMessage = this.props.t("An unknown error occurred");
      if (error.response) {
        errorMessage = error.response.message || "Server Error"; // Server error
      } else if (error.message) {
        errorMessage = error.message; // Client-side or network error
      }
      Swal.fire({
        type: "error",
        title: "Oops...",
        text: `${errorMessage}`,
      });
      return false
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const {guestDetail, describe, agentDetail} = this.props.vf2
    const { form } = this.state;

    return (
      <>
        <div style={{ margin: "30px", position: 'relative' }}>
          <Header 
            title={this.props.t("Flight and Other Requests")} 
            subtitle={this.props.t("Tell us about your international arrival details")} 
            selectedGuest={guestDetail}
            agent={agentDetail}
          />

          <SectionForm title={this.props.t("Arrival")} subtitle={this.props.t("Let us know about your arrival details")}>
            <Grid container spacing={2} sx={{ padding: '10px 0' }}>
              <Grid item xs={12}>
                <div style={{
                  padding: '16px',
                  paddingBottom: '10px',
                  backgroundColor: '#F9FAFB',
                  border: 'solid 1px #EAECF0',
                  borderRadius: 10,
                }}>
                  <Typography variant="body1" sx={{ marginBottom: '8px' }}>
                    {this.props.t("Who are you updating the flight information for?")}
                  </Typography>
                  <div style={{ position: 'relative' }}>
                    <CustomRadioButton
                      label={this.props.t("For myself")}
                      sublabel={this.props.t("Update myself only.")}
                      value="Myself"
                      checked={form.Update_For__c === "Myself"}
                      onChange={this.handleChange}
                      name="Update_For__c"
                    />
                    <CustomRadioButton
                      label={this.props.t("For myself and travelling companions")}
                      sublabel={this.props.t("Update for my traveling companions.")}
                      value="Companions"
                      checked={form.Update_For__c === "Companions"}
                      onChange={this.handleChange}
                      name="Update_For__c"
                    />
                  </div>
                </div>
              </Grid>

              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Date of Arrival in Bali")}</Typography>
                <InputDate
                  sx={{ marginTop: 0 }}
                  name="arrivalDate"
                  value={form.arrivalDate ? dayjs(form.arrivalDate) : null}
                  format={'DD-MMM-YYYY'}
                  onChange={(e) => 
                    this.handleChange({target: {name: 'arrivalDate', value: dayjs(e.$d).format("YYYY-MM-DD")  
                  }})}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t('Time Arrival')}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="time"
                  name="arrivalTime"
                  value={form.arrivalTime}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Arrival Flight")} #</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder="Number"
                  type="text" // Use 'text' instead of 'number' for flight numbers
                  name="Arrival_Flight_No__c"
                  value={form.Arrival_Flight_No__c}
                  onChange={this.handleChange}
                  inputProps={{
                    maxLength: 50, 
                  }}
                />
              </Grid>
              <Grid item xs={12}>
              <Typography variant="body1" sx={{ color: '#667085', fontWeight: 300, marginTop:'-10px' }}>
                ({this.props.t("Please ensure the flight details are correct so that we can greet you after you have passed through immigration.")})
              </Typography>
</Grid>

              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Departure Date from Bali")}</Typography>
                <InputDate
                  sx={{ marginTop: 0 }}
                  name="departureDate"
                  value={form.departureDate ? dayjs(form.departureDate) : null}
                  format={'DD-MMM-YYYY'}
                  onChange={(e) => 
                    this.handleChange({target: {name: 'departureDate', value: dayjs(e.$d).format("YYYY-MM-DD")  
                  }})}
                />
                {/* <Typography variant="body1" sx={{ color: '#667085', fontWeight: 300 }}>
                  (Please supply date in the format DD/MM/YYYY)
                </Typography> */}
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Time Departure")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="time"
                  name="departureTime"
                  value={form.departureTime}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Departure Flight")} #</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder="Number"
                  type="text" // Use 'text' instead of 'number' for flight numbers
                  name="Departure_Flight_No__c"
                  value={form.Departure_Flight_No__c}
                  onChange={this.handleChange}
                  inputProps={{
                    maxLength: 50, 
                  }}
                />
                
              </Grid>
              <Typography variant="body1" sx={{ color: '#F04438', fontWeight: 300, marginLeft: '16px' }}>
                {this.props.t("For further details on Indonesia Visa Regulations please visit our")}
                  <a
                    href="https://www.wakatobi.com/faq/#visa"
                    style={{
                      textDecoration: "underline",
                      marginLeft: '7px',
                      fontWeight: 600
                    }}>
                    {this.props.t("FAQ Page")}
                  </a>
              </Typography>

              <Grid item xs={12}>
                <Typography variant="body1">{this.props.t("Estimated Luggage Weight")}</Typography>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    labelId="luggage-weight-label"
                    name="Estimated_Luggage_Weight__c"
                    value={form.Estimated_Luggage_Weight__c || ''}
                    onChange={this.handleChange}
                    variant="outlined"
                    sx={{ marginTop: 0 }}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>{this.props.t("Select Weight")}</MenuItem>
                    {getPicklist('Estimated_Luggage_Weight__c', describe).map((value,i) => 
                      <MenuItem value={value} key={i}>{value}</MenuItem>  
                    )}
                  </Select>
                </FormControl>
                <Typography variant="body1" sx={{ color: '#667085', fontWeight: 300 }}>
                  ({this.props.t("Please note, this information assists us to anticipate the remaining cargo space available to supply our kitchens with perishable goods. Further information regarding luggage allowance can be found")} 
                  <a
                    href="https://www.wakatobi.com/faq/#transfer"
                    style={{
                      marginLeft: '3px',
                      textDecoration: "underline",
                      color: '#667085',
                      fontWeight: 600
                    }}>
                    {this.props.t("here")}
                  </a>)
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="body1">{this.props.t("Bali Hotel Name")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="Arrival_Hotel__c"
                  placeholder={this.props.t("Bali Hotel Name")}
                  value={form.Arrival_Hotel__c}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{this.props.t("Travel Agent or Contact Person")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={this.props.t("Full Name")}
                  name="My_travel_agent__c"
                  value={form.My_travel_agent__c}
                  onChange={this.handleChange}
                />
              </Grid>
              

              <Grid item xs={12}>
                <Typography variant="body1">{this.props.t("Any other special requests for the Bali office?")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder={`${this.props.t("Enter a description")}..`}
                  multiline // Set to true for textarea
                  rows={5} // Number of visible lines
                  name="Any_other_special_requests_for_our_Bali__c"
                  value={form.Any_other_special_requests_for_our_Bali__c}
                  onChange={this.handleChange}
                />
              </Grid>
            </Grid>
          </SectionForm>

          <NavigationButtons
            nextUrl={`${URL_PREFIX}/vf2/wizard/summary`}
            backUrl={`${URL_PREFIX}/vf2/wizard/stay`}
            onSave={this.handleSave}
            isLoading={this.state.isLoading}
            showSave
            showBack
            showNext // Change to false to hide the Next button
          />
        </div>
      </>
    );
  }
}

VF2Step4.propTypes = {
  vf2: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      editGuestDetail,
      getSalesOrderDetail,
      returnUpdate
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  vf2: state.vf2,
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VF2Step4));